/* WellFitPaws listicle presell: live date and month, PDP link params, sticky bar after the reveal. */
(function () {
  'use strict';
  var KEEP = /^(utm_|fbclid$|gclid$|ttclid$|msclkid$|preview_theme_id$)/;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function fillDates() {
    var now = new Date();
    document.querySelectorAll('[data-wfp-dateline]').forEach(function (box) {
      if (box.getAttribute('data-auto') !== 'true') return;
      try {
        var d = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Europe/London' }).format(now);
        var t = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Europe/London' }).format(now);
        var de = box.querySelector('[data-wfp-date]');
        var te = box.querySelector('[data-wfp-time]');
        if (de) de.textContent = d;
        if (te) te.textContent = t;
      } catch (e) { /* keep the text from the settings */ }
    });
    document.querySelectorAll('[data-wfp-month]').forEach(function (el) {
      if (el.getAttribute('data-auto') !== 'true') return;
      try {
        el.textContent = new Intl.DateTimeFormat('en-GB', { month: 'long', timeZone: 'Europe/London' }).format(now).toUpperCase();
      } catch (e) { /* keep the text from the settings */ }
    });
  }

  function mergeLinks() {
    var incoming = new URLSearchParams(window.location.search);
    var keys = [];
    incoming.forEach(function (v, k) { if (KEEP.test(k)) keys.push(k); });
    if (!keys.length) return;
    document.querySelectorAll('a[data-wfp-pdp]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      try {
        var u = new URL(href, window.location.href);
        var slot = a.getAttribute('data-wfp-slot');
        keys.forEach(function (k) {
          if (k === 'utm_content' && slot) u.searchParams.set('wfp_cta', slot);
          u.searchParams.set(k, incoming.get(k));
        });
        a.setAttribute('href', u.toString());
      } catch (e) { /* leave the link as it is */ }
    });
  }

  var stickyState = { armed: false, ctaOn: 0, bar: null, io: null };

  function applySticky() {
    var s = stickyState;
    if (!s.bar) return;
    var show = s.armed && s.ctaOn === 0;
    s.bar.classList.toggle('is-on', show);
    s.bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function initSticky() {
    var bar = document.querySelector('[data-wfp-sticky]');
    if (!bar) return;
    var s = stickyState;
    document.querySelectorAll('body > [data-wfp-sticky]').forEach(function (old) { if (old !== bar && old.parentNode === document.body) old.remove(); });
    if (bar.classList.contains('wfp-sticky--design')) return; /* theme editor: bar sits in the flow */
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    s.bar = bar;
    document.documentElement.classList.add('wfp-has-sticky');
    document.documentElement.style.setProperty('--wfp-sticky-h', (bar.offsetHeight || 96) + 'px');

    if (s.io) s.io.disconnect();
    s.ctaOn = 0;
    if ('IntersectionObserver' in window) {
      var on = new Set();
      s.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) on.add(e.target); else on.delete(e.target); });
        s.ctaOn = on.size;
        applySticky();
      }, { threshold: 0.2 });
      document.querySelectorAll('[data-wfp-cta]').forEach(function (el) { s.io.observe(el); });
    }

    var fallback = parseInt(bar.getAttribute('data-fallback') || '650', 10);
    function check() {
      var reveal = document.querySelector('[data-wfp-reveal]');
      var passed = reveal
        ? reveal.getBoundingClientRect().top <= window.innerHeight / 2
        : window.pageYOffset >= fallback;
      if (passed) s.armed = true;
      applySticky();
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; check(); });
    }
    if (!s.bound) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      s.bound = true;
    }
    s.check = check;
    check(); /* page opened already past the reveal (reload): show; at the top this stays hidden */
  }

  function init() {
    fillDates();
    mergeLinks();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
